import * as React from 'react'
import * as ReactDOM from 'react-dom'
import App from './App'
import './index.scss'
import registerServiceWorker from './registerServiceWorker'

// app注入
import { NativeInject } from './utils/app'
NativeInject.init()

ReactDOM.render(
    <App />,
    document.getElementById('root') as HTMLElement
)
registerServiceWorker()


// WEBPACK FOOTER //
// ./src/index.tsx